var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJustPrize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1707481916"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33699",
    d: "M2 5.46293C2 4.8111 2.47183 4.2618 3.12076 4.20041C4.10237 4.10755 5.72878 4.00009 8 4C10.2714 3.99991 11.8979 4.1074 12.8794 4.20033C13.5283 4.26175 14 4.811 14 5.46275V5.51031C14 6.30499 13.3091 6.92672 12.5169 6.86349C11.3636 6.77143 9.68182 6.66667 8 6.66667C6.31818 6.66667 4.63636 6.77143 3.4831 6.86349C2.69094 6.92673 2 6.305 2 5.51031V5.46293Z",
    stroke: "#111111",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 33700",
    d: "M2.66659 7.00001C2.66659 7.00001 4.99992 6.66667 7.99992 6.66667C10.9999 6.66667 13.3333 7.00001 13.3333 7.00001C13.3333 7.00001 13.6666 8.00001 13.6666 10.3333C13.6666 11.6213 13.4634 12.6046 13.2814 13.2272C13.1397 13.7119 12.6809 14 12.1759 14H3.82396C3.31893 14 2.86012 13.7119 2.7184 13.2272C2.53639 12.6046 2.33325 11.6213 2.33325 10.3333C2.33325 8.00001 2.66659 7.00001 2.66659 7.00001Z",
    stroke: "#111111",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 768",
    d: "M8 4V14",
    stroke: "#111111",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66675 1.33328C5.56218 1.33328 4.66675 2.22871 4.66675 3.33328C4.66675 3.56704 4.70685 3.79143 4.78055 3.99995H6.66675H8.55294C8.62664 3.79143 8.66675 3.56704 8.66675 3.33328C8.66675 2.22871 7.77132 1.33328 6.66675 1.33328ZM6.66675 3.99995C7.03494 3.99995 7.33341 3.70147 7.33341 3.33328C7.33341 2.96509 7.03494 2.66662 6.66675 2.66662C6.29856 2.66662 6.00008 2.96509 6.00008 3.33328C6.00008 3.70147 6.29856 3.99995 6.66675 3.99995Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.3335 1.33328C8.22893 1.33328 7.3335 2.22871 7.3335 3.33328C7.3335 3.56704 7.3736 3.79143 7.4473 3.99995H9.3335H11.2197C11.2934 3.79143 11.3335 3.56704 11.3335 3.33328C11.3335 2.22871 10.4381 1.33328 9.3335 1.33328ZM9.3335 3.99995C9.70169 3.99995 10.0002 3.70147 10.0002 3.33328C10.0002 2.96509 9.70169 2.66662 9.3335 2.66662C8.96531 2.66662 8.66683 2.96509 8.66683 3.33328C8.66683 3.70147 8.96531 3.99995 9.3335 3.99995Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustPrize);
export default __webpack_public_path__ + "static/media/JustPrize.2393379bd40f0fd0554799d702b961a2.svg";
export { ForwardRef as ReactComponent };